// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';

const checkExpire = (expire) => (!(!expire || expire < parseInt(Date.now() / 1E3, 10)));

const isTokenValid = (token) => {
  try {
    const { expire, exp, iss } = jwt_decode(token);

    if (iss) {
      return checkExpire(exp);
    }

    return checkExpire(expire);
  } catch (e) {
    return false;
  }
};

export default isTokenValid;
